import { defineTheme } from '../contracts.js';
export const halloween = defineTheme({
    id: 'halloween',
    displayName: 'Halloween',
    lifecycle: 'ready',
    selectable: true,
    implementation: 'native',
    capabilities: {
        alerts: 'available',
        welcomes: 'reserved',
        wam: 'available',
        startup: 'external',
        achievements: 'reserved',
        viewerSounds: 'reserved',
        privateChatSounds: 'reserved',
    },
});
//# sourceMappingURL=registration.js.map